
URL = globalThis.URL
import __vite__wasmUrl from "/Users/liepauls/dev/plug/plug-web/candid-parse/pkg/candid_parse_bg.wasm?url"
import __vite__initWasm from "/__vite-plugin-wasm-helper"


const __vite__wasmModule = await __vite__initWasm({  }, __vite__wasmUrl);
export const memory = __vite__wasmModule.memory;
export const generate = __vite__wasmModule.generate;
export const __wbindgen_add_to_stack_pointer = __vite__wasmModule.__wbindgen_add_to_stack_pointer;
export const __wbindgen_malloc = __vite__wasmModule.__wbindgen_malloc;
export const __wbindgen_realloc = __vite__wasmModule.__wbindgen_realloc;
export const __wbindgen_free = __vite__wasmModule.__wbindgen_free;
